import CloseIcon from '@src/components/icons/Close'
import { ITransactionStatus } from '@src/types/transactionStatus'
import { formatExchangeAmountWithCommas } from '@src/utils/exchangeUtils'
import { useConfigStore } from '@src/zustand_stores'
import { useApplicationStore } from '@src/zustand_stores/application.store'

const TransactionStatusCard = (props: any) => {
    const { exchange, closeToast }: { exchange: ITransactionStatus; closeToast: any } = props
    const setCurrentModalId = useApplicationStore(state => state.setCurrentModalId)
    const availableNetworks = useConfigStore(config => config.availableNetworks)
    const { sellData, buyData } = exchange

    return (
        <div
            className='w-[360px] max-w-[calc(100%-24px)] rounded-md border border-modal-border/15 bg-modal-background'
            onClick={() => {
                setCurrentModalId(exchange.exchangeId)
                closeToast()
            }}
        >
            <div className='mt-2 flex items-center justify-between border-b border-modal-border/10 px-4 py-2'>
                <span className='text-lg font-semibold'>Transaction Update</span>
                <CloseIcon
                    className='cursor-pointer hover:opacity-70'
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        closeToast()
                    }}
                />
            </div>
            <div className='flex w-full flex-col py-4'>
                <div className='mx-auto mb-6 flex items-center'>
                    <div className='relative mr-[12px]'>
                        <img
                            src={sellData.token?.logoURI}
                            onError={e => {
                                e.currentTarget.src = '/assets/token/unknown.png'
                            }}
                            className='relative w-8 rounded-full shadow-[3px_3px_5px_0px_rgba(0,0,0,.55)] md:w-10'
                        />
                        <img
                            src={availableNetworks[sellData.chainId]?.icon}
                            className='absolute -right-[12px] bottom-0 w-5 rounded-full shadow-[4px_2px_2px_0_rgba(0,0,0,.2)] md:w-6'
                        />
                        <span className='absolute left-[35px] max-w-[80px] truncate whitespace-nowrap font-bold italic md:text-lg'>
                            {formatExchangeAmountWithCommas(sellData)}
                        </span>
                    </div>

                    <img src='/images/arrow-right.png' alt='arrow' className='mx-6 w-12 animate-pulse' />

                    <div className='relative mr-[12px]'>
                        <img
                            src={buyData.token?.logoURI}
                            className='relative w-8 rounded-full shadow-[3px_3px_5px_0px_rgba(0,0,0,.55)] md:w-10'
                        />
                        <img
                            src={availableNetworks[buyData.chainId]?.icon}
                            className='absolute -right-[12px] bottom-0 w-5 rounded-full shadow-[4px_2px_2px_0_rgba(0,0,0,.2)] md:w-6'
                        />
                        <span className='absolute left-[35px] max-w-[80px] truncate whitespace-nowrap font-bold italic md:text-lg'>
                            {formatExchangeAmountWithCommas(buyData)}
                        </span>
                    </div>
                </div>
                <span className='mt-1 px-4 py-2 text-sm text-gray-600'>
                    This status card will disappear in a moment but we will continue processing your swap!
                </span>
            </div>
        </div>
    )
}

export default TransactionStatusCard
